// ============================================================================
// SEED / DEMO PROJECTS
// Placeholder project listings so the Project Board isn't empty while real
// projects are posted. Same pattern as seedMembers/seedGroups/seedJobs:
// `isSeed: true`, `seed-project-*` ids, all fields the board reads (incl.
// client + skills[] so the board never crashes). Admin can hide ALL demo
// content via the dashboard toggle. Delete entries as real projects come in.
// ============================================================================

export const SEED_PROJECTS = [
  {
    id: 'seed-project-1', isSeed: true,
    title: 'Sell-Side M&A Advisory — SaaS Company',
    client: 'Confidential SaaS Founder',
    industry: 'Technology', specialty: 'Investment Banking',
    location: 'Remote', budget: '$50,000 - $100,000', duration: '3-6 months',
    deadline: '2026-09-01',
    description: 'Run a sell-side process for a ~$10M ARR vertical SaaS business: positioning, buyer outreach, and negotiation through close.',
    requirements: ['M&A advisory experience', 'SaaS sector knowledge', 'Buyer network'],
    skills: ['M&A', 'Valuation', 'SaaS', 'Deal Structuring'],
    contactEmail: 'projects@example.com',
    featured: true, status: 'open', postedBy: 'seed', postedDate: '2026-06-11',
  },
  {
    id: 'seed-project-2', isSeed: true,
    title: 'Quality of Earnings — Manufacturing Acquisition',
    client: 'Midwest PE Firm',
    industry: 'Manufacturing', specialty: 'Accounting',
    location: 'Chicago, IL', budget: '$25,000 - $60,000', duration: '4-8 weeks',
    deadline: '2026-08-15',
    description: 'Perform buy-side quality of earnings and working-capital analysis on a $40M manufacturing target.',
    requirements: ['Transaction services / QoE experience', 'CPA preferred'],
    skills: ['Due Diligence', 'Quality of Earnings', 'Accounting', 'Financial Analysis'],
    contactEmail: 'projects@example.com',
    featured: false, status: 'open', postedBy: 'seed', postedDate: '2026-06-13',
  },
  {
    id: 'seed-project-3', isSeed: true,
    title: 'Fairness Opinion — Healthcare Merger',
    client: 'Regional Health System',
    industry: 'Healthcare', specialty: 'Valuation',
    location: 'Remote', budget: '$30,000 - $75,000', duration: '6-10 weeks',
    deadline: '2026-09-30',
    description: 'Provide an independent fairness opinion for a proposed healthcare merger, including valuation analysis and board presentation.',
    requirements: ['Valuation / fairness opinion experience', 'Healthcare sector knowledge'],
    skills: ['Valuation', 'Fairness Opinion', 'Healthcare', 'Financial Modeling'],
    contactEmail: 'projects@example.com',
    featured: false, status: 'open', postedBy: 'seed', postedDate: '2026-06-15',
  },
];
